import React, { useCallback } from 'react';
import { FlatList, StyleSheet } from 'react-native';

import { EventInfo, EventInfoWithoutPlayers } from '@/api/events/types/types';
import { SizedBox } from '@/components/SizedBox';
import { SinglePlayerProfileProvider } from '@/feature/fantasy-event-sheets/SinglePlayerProfileProvider';

import { NoEvents } from './DedicatedEventCardsList';
import { PickemEventLobbyCard } from './PickemEventCard';
import { EventCardSkeleton } from './Skeletons/EventCardSkeleton';

export const DEFAULT_EVENT_CARD_LIST_HEIGHT = 118;

/**
 * Component that renders the event cards list
 */
export const EventCardsList = ({
    sortedEvents,
    loading,
}: {
    sortedEvents: EventInfoWithoutPlayers[];
    loading: boolean;
}) => {
    const renderItem = useCallback(({ item, index }: { item: EventInfo | EventInfoWithoutPlayers; index: number }) => {
        return (
            <SinglePlayerProfileProvider>
                <PickemEventLobbyCard variant="lobby" pickemEvent={item} index={index} />
            </SinglePlayerProfileProvider>
        );
    }, []);

    const data = loading ? new Array(5) : sortedEvents;

    return (
        <FlatList
            ListEmptyComponent={NoEvents}
            contentContainerStyle={styles.contentContainer}
            data={data}
            horizontal
            renderItem={({ item, index }) => (loading ? <EventCardSkeleton /> : renderItem({ item, index }))}
            showsHorizontalScrollIndicator={false}
            ItemSeparatorComponent={ItemSeparatorComponent}
        />
    );
};

const ItemSeparatorComponent = () => <SizedBox value={12} />;

const styles = StyleSheet.create({
    contentContainer: {
        paddingHorizontal: 16,
        paddingBottom: 8,
        paddingTop: 20,
    },
});
